<template>
  <div>
    <div class="login">
      <p class="PLoginTitle">
        <span><router-link to="/"><img src="../../assets/images/users/Return.png"></router-link></span>
        <span>会員登録</span>
        <span></span>
      </p>
      <p class="LoginTitle">会員登録</p>
      <div class="login_input loginOne">
        <input type="text" name="login_email" v-model="login_email" placeholder="メールアドレス">
        <span v-show="errors.has('login_email')" class="error">{{ errors.first('login_email') }}</span>
      </div>
      <div class="login_input">
        <input type="password" name="login_pwd" v-model="login_pwd" placeholder="パスワード">
        <span v-show="errors.has('login_pwd')" class="error">{{ errors.first('login_pwd') }}</span>
        <span class="error">{{errorMessage}}</span>
      </div>
      <p class="forgetPwd" @click="forgetPwd">
        <span>パスワードを忘れた場合?</span>
      </p>
      <button class="login_home" @click="toHome">ログイン</button>
      <button class="register" @click="register">新規登録（無料)</button>
    </div>
  </div>
</template>

<script>
  import {login} from './../../api/interface/users'
  import VeeValidate, {Validator} from 'vee-validate'
  import cn from 'vee-validate/dist/locale/zh_CN'
  Validator.localize('cn', cn);
  import {bus} from '../../main'
  const dict = {
    cn: {messages: {required: (name) => `${name}必要!`}}
  };
  Validator.localize(dict);
  export default{
    name: "",
    validator: null,
    data(){
      return {
        errors: null,
        start: false,
        login_email: "",
        login_pwd: "",
        errorMessage: ""
      }
    },
    methods: {
      toHome(){
        this.$router.push({path: "/404"});
      },
      forgetPwd(){
        this.$router.push({path: "/404"});
      },
      register(){
        this.$router.push({path: "/register"});
      }
    },
    components: {},
    created(){
      this.validator = new Validator({});  // 初始化Validator对象
      Validator.extend('login_email', {
        getMessage: field => '正しいメールアドレスを入力してください',
        validate: value => /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)  // 验证条件
      });
      Validator.extend('login_pwd', {
        getMessage: field => '入力内容が正しくありません',
        validate: value => /(?=.*[a-zA-Z])(?=.*[\d])[\w\W]{6,20}/.test(value)  // 验证条件
      });
      this.validator.attach({name: 'login_email', rules: 'required|login_email|', alias: 'メールアドレス'});
      this.validator.attach({name: 'login_pwd', rules: 'required|login_pwd|', alias: 'パスワード'});
      this.$set(this, 'errors', this.validator.errors);
    },
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: 0px) and(max-width: 749px) {
    .login {
      width: 100%;
      margin: 0 auto;
      letter-spacing: $letter;
      .PLoginTitle {
        height: 50px;
        line-height: 50px;
        background-color: $TitColor;
        width: 100%;
        color: $whiteColor;
        display: flex;
        font-size: 16/$default-w+rem;
        justify-content: space-between;
        span:nth-child(1),
        span:nth-child(3) {
          height: 50px;
          width: 50px;
        }
        img {
          width: 30px;
          height: 30px;
          margin: 10px;
        }
      }
      .LoginTitle {
        display: none;
      }
      .login_input {
        width: 286px;
        height: 35px;
        margin: 0 auto;
        margin-top: 30px;
        background-color: white;
        border-radius: 5px;
        border: 1px solid $fontColor;
        input {
          width: 278px;
          height: 34px;
          margin-left: 5px;
          outline: none;
          border: none;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }
      }
      .loginOne {
        margin-top: 100px;
      }
      .forgetPwd {
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin-top: 30px;
        span {
          font-size: 14px;
          color: $fontColor;
          display: inline-block;
          height: 30px;
          border-bottom: 1px solid $fontColor;
        }
      }
      button {
        width: 5rem;
        height: 30px;
        margin-left: 2.5rem;
        margin-top: 30px;
        text-align: center;
        outline: none;
        letter-spacing: $letter;
        line-height: 30px;
        border-radius: 5px;
        background-color: white;
        border: 1px solid $fontColor;
      }
      .register {
        color: white;
        background-color: $fontColor;
        margin-bottom: 30/$default-w+rem;
      }
    }
  }

  @media screen and(min-width: 750px) {
    .login {
      height: 500px;
      width: 400px;
      margin: 0 auto;
      margin-top: 100px;
      letter-spacing: $letter;
      .PLoginTitle {
        display: none;
      }
      .LoginTitle {
        height: 20px;
        line-height: 20px;
        width: 100%;
        text-align: center;
        span {
          color: $fontColor;
          margin-top: 20px;
          display: inline-block;
          height: 25px;
          border-bottom: 1px solid $fontColor;
          text-align: center;
        }
      }
      .login_input {
        width: 386px;
        height: 35px;
        margin-left: 7px;
        margin-top: 30px;
        background-color: white;
        border-radius: 5px;
        border: 1px solid $fontColor;
        input {
          width: 380px;
          height: 34px;
          margin-left: 5px;
          outline: none;
          border: none;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }
      }
      .forgetPwd {
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin-top: 30px;
        span {
          cursor: default;
          font-size: 14px;
          color: $fontColor;
          display: inline-block;
          height: 30px;
          border-bottom: 1px solid $fontColor;
        }
      }
      button {
        width: 290px;
        height: 30px;
        text-align: center;
        margin-left: 55px;
        outline: none;
        letter-spacing: $letter;
        line-height: 30px;
        border-radius: 5px;
        background-color: white;
        border: 1px solid $fontColor;
      }
      .login_home {
        margin-top: 100px;
      }
      .register {
        margin-top: 30px;
        color: white;
        background-color: $fontColor;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/users/login.vue